<form [formGroup]="form">
  <div class="row">
    <div class="col-6">
      <div class="form-group validateMe">
        <label class="form-label" for="Name">{{'lang.globals.name' | translate}}</label>
        <input class="form-control" formControlName="Name" id="Name" sbAutofocus type="text">
      </div>
    </div>
    <div class="col-6">
      <div class="form-group validateMe">
        <label class="form-label" for="Description">{{'lang.globals.description' | translate}}</label>
        <input class="form-control mr-1" formControlName="Description" id="Description" type="text">
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-xl-6">
      <div class="form-group">
        <sb-local-date-time-input id="From" formControlName="From"
                                  [title]="translate.instant('lang.globals.startTime')" [seconds]="false"
                                  [kind]="'RANGE_START'"
                                  (modelChange)="localDateTimeInputFrom($event)">
        </sb-local-date-time-input>
        <div *ngIf="From.touched && From.errors?.required" class="alert alert-danger">
          {{'lang.commercialEdit.startTimeWarning' | translate}}</div>
        <div *ngIf="form.touched && form.errors?.endDateAfterStartDate" class="alert alert-danger">
          {{'lang.commercialEdit.startTimeCorrection' | translate}}</div>
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <sb-local-date-time-input id="Till" formControlName="Till"
                                  [title]="translate.instant('lang.globals.dueTime')" [seconds]="false"
                                  [kind]="'RANGE_END'"
                                  [minDate]="From.value"
                                  (modelChange)="localDateTimeInputTill($event)"></sb-local-date-time-input>
        <div *ngIf="Till.touched && Till.errors?.required" class="alert alert-danger">
          {{'lang.commercialEdit.dueTimeWarning' | translate}}</div>
        <div *ngIf="form.touched && form.errors?.endDateAfterStartDate" class="alert alert-danger">
          {{'lang.commercialEdit.dueTimeCorrection' | translate}}</div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="isInModalContext">
    <div
      class="col mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
      <button class="btn btn-secondary"
              (click)="cancel()">{{'lang.globals.cancel' | translate}}</button>
      <button class="btn btn-primary mr-2" [disabled]="form.invalid" type="submit"
              (click)="ok()">{{'lang.globals.submit' | translate}}</button>

    </div>
  </div>
</form>
